module.exports = __webpack_public_path__ + "static/media/md.5f734d92.svg";